module.exports = __webpack_public_path__ + "static/img/sign.8089256.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diy/sign.png
// module id = bqKU
// module chunks = 174